import { Game } from 'types'
import audioGame3 from 'assets/sounds/a-noite-no-castelo.mp3'
import audioGame6 from 'assets/sounds/composicao-com-gravuras.mp3'

export const gameListEs: Game[] = [
  {
    id: '1',
    gameTitle: 'Juego 1',
    content: [
      {
        text: 'Pregunta y Respuesta con cuerdas sueltas en pizzicato',
        style: ['title1'],
      },
      {
        text: 'Autoría: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Propiciar a los estudiantes la conciencia de su individualidad y su papel dentro del colectivo; establecer las ideas de narrativa musical y de preguntas y respuestas, enfatizando el uso de las cuatro cuerdas del violonchelo, del pizzicato, de diferentes ritmos, métricas, timbres y dinámicas.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: 'Organizar a los estudiantes en un semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Explicar a los estudiantes qué podría ser una pregunta y qué podría ser una respuesta dentro de una narrativa musical.',
        style: ['itemList'],
      },
      {
        text:
          'Ejemplificar utilizando únicamente las cuerdas sueltas del violonchelo, contemplando diferentes ritmos, métricas, dinámicas y variaciones de carácter.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer una pregunta al primer estudiante, quien debe tocar una respuesta. En seguida, hacer lo mismo con el segundo estudiante, y así sucesivamente, abordando a todos los estudiantes, uno a uno, individualmente.',
        style: ['itemList'],
      },
      {
        text: 'Realizar algunas vueltas del juego.',
        style: ['itemList'],
      },
      {
        text: 'Organizar a los estudiantes en dúos, dispuestos en diferentes puntos del aula.',
        style: ['itemList'],
      },
      {
        text:
          'Un estudiante de cada pareja debe hacer las preguntas, y el otro estudiante debe hacer las respuestas durante algunos minutos.',
        style: ['itemList'],
      },
      {
        text: 'Cambiar los roles de la actividad anterior.',
        style: ['itemList'],
      },
      {
        text: 'Organizar nuevamente al grupo en un semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Cada pareja va hacia el centro del semicírculo y realiza algunas series de preguntas y respuestas, presentándolas a sus compañeros de clase.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Proporcionar a los estudiantes autonomía de decisión con relación al número de preguntas y respuestas que presentarán a sus compañeros, a la distribución de los roles y a las combinaciones entre ellos que determinen el inicio y el fin de la presentación a sus pares.',
        style: ['itemList'],
      },
      {
        text:
          'Se observa, con frecuencia, un aumento de la complejidad en la elaboración de las preguntas y respuestas de los estudiantes a lo largo de las actividades. Es interesante enfatizar este hecho.',
        style: ['itemList'],
      },
    ],
  },

  {
    id: '2',
    gameTitle: 'Juego 2',
    content: [
      {
        text: 'Señal Verde X Señal Roja',
        style: ['title1'],
      },
      {
        text: 'Autoría: Maria Teresa Alencar de Brito',
        style: ['paragraph'],
      },
      {
        text: 'Adaptación: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabajar las diferencias entre sonido y silencio, así como su importancia y su papel dentro de la construcción musical; profundizar la importancia de la colectividad dentro del proceso musical; establecer la idea de diálogo musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: 'Organizar a los estudiantes en un semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer a los estudantes que exploren diferentes sonoridades de sus violonchelos, a través de técnicas extendidas.',
        style: ['itemList'],
      },
      {
        text:
          'Presentar una determinada sonoridad y proponer que los estudiantes, de forma conjunta, la reproduzcan.',
        style: ['itemList'],
      },
      {
        text:
          'Estimular a los estudiantes a explorar, individualmente, sus instrumentos, buscando nuevas sonoridades.',
        style: ['itemList'],
      },
      {
        text:
          'Cada estudiante deberá presentar una sonoridad sobre la que haya investigado a los demás compañeros del grupo, quienes deben, juntos, reproducirla.',
        style: ['itemList'],
      },
      {
        text:
          'Presentar dos tarjetas a los estudiantes, una de color verde y otra de color rojo. Asociar las tarjetas con las normas de tránsito: el verde significará “tocar”, y el rojo significará “ no tocar”.',
        style: ['itemList'],
      },
      {
        text:
          'Ejecutar algunas combinaciones con las tarjetas, proponiendo a los estudiantes que toquen los sonidos que quieran.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer algunas variaciones de dinámica, dependiendo de la secuencia en la que se presenten las tarjetas a los estudiantes.',
        style: ['itemList'],
      },
      {
        text:
          'Elegir a un estudiante para ser el “maestro” de los demás, quien debe cumplir la función de presentar las tarjetas a sus compañeros.',
        style: ['itemList'],
      },
      {
        text:
          'Dividir la clase en dos grupos, eligiendo un “maestro” para cada grupo. Cada “maestro” recibirá un conjunto de tarjetas verdes y rojas.',
        style: ['itemList'],
      },
      {
        text:
          'Cada grupo deberá seguir las indicaciones de sus respectivos “maestros”, quienes deben comunicarse de forma no verbal y propiciar la interacción y el diálogo musical entre los dos grupos. ',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Estar atento y estimular la escucha de los estudiantes, resaltando que las diferentes combinaciones de sonidos y silencios establecidas entre los “maestros” proporcionan la creación de una narrativa musical.',
        style: ['itemList'],
      },
    ],
  },

  {
    id: '3',
    gameTitle: 'Juego 3',
    content: [
      {
        text: 'La noche en el castillo',
        style: ['title1'],
      },
      {
        text: 'Autoría: Claudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Establecer relaciones entre lo imaginario y lo sonoro; reforzar la confianza entre pares; desarrollar el poder de elección dentro de la creación musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text:
          'Contar una historia a los estudiantes sobre un viajero que llega a un castillo embrujado en medio de una noche de tormenta. ',
        style: ['itemList'],
      },
      {
        text:
          'Hacer un inventario de sonidos que podrían formar parte de este paisaje (truenos, ráfagas de viento, sonido de la lluvia, murciélagos, fantasmas, etc.), así como objetos que estarían dentro del castillo (cuadros, jarrones, muebles antiguos, etc.).',
        style: ['itemList'],
      },
      {
        text:
          'Distribuir a los estudiantes en diferentes puntos del aula, con una cierta distancia entre ellos.',
        style: ['itemList'],
      },
      {
        text:
          'Elegir a uno de los estudiantes para representar al viajero. Este estudiante caminará por el castillo, evitando chocarse con los “objetos”, guiado por su audición. Cuando el viajero se acerca a un objeto del castillo, el estudiante que representa este objeto ejecutará su sonido específico. A medida que el viajero se aleja del objeto, el sonido disminuye su intensidad, y el estudiante que esté más cerca del viajero comenzará a ejecutar el sonido correspondiente a su objeto, y así sucesivamente, componiendo una narrativa musical.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'A fin de estimular a los estudiantes a intensificar su capacidad de escucha, proponer que el viajero permanezca más tiempo frente al objeto que quiere escuchar o que regrese a un determinado objeto que quiere volver a escuchar, ejerciendo un papel activo en la composición de la narrativa.',
        style: ['itemList'],
      },
      {
        style: ['audio'],
        audio: audioGame3,
      },
    ],
  },

  {
    id: '4',
    gameTitle: 'Juego 4',
    content: [
      {
        text: 'Firma Musical',
        style: ['title1'],
      },
      {
        text: 'Autoría: Wanderson Cruz',
        style: ['paragraph'],
      },
      {
        text: 'Adaptación: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Posibilitar la experiencia de creación a partir de células musicales pre-establecidas; establecer las diferencias entre polifonías y homofonías; incentivar el poder de elección dentro de la creación musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: 'Organizar a los estudiantes en un semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Preguntar a los estudiantes qué es una firma, y relacionar las respuestas con lo que podría ser una firma musical.',
        style: ['itemList'],
      },
      {
        text:
          'Dar un ejemplo utilizando los sonidos provenientes de las técnicas tradicionales y de las técnicas extendidas. ',
        style: ['itemList'],
      },
      {
        text:
          'Proponer que los estudiantes, individualmente, creen sus firmas musicales utilizando los sonidos que quieran y las presenten a los demás compañeros del grupo.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer que los estudiantes ejecuten sus firmas más de una vez, con el fin de que podamos verificar si ellas siguen siendo las mismas tras dos ejecuciones.',
        style: ['itemList'],
      },
      {
        text:
          'Elegir a uno de los estudiantes del grupo para ser el “maestro” que deberá componer una música utilizando solamente las firmas musicales elaboradas por los estudiantes.',
        style: ['itemList'],
      },
      {
        text:
          'El “maestro” debe crear señales que indiquen cuándo un estudiante debe comenzar a tocar su firma, cuándo debe parar, con qué intensidad, velocidad y otras variables, además de indicar cuántos estudiantes deben tocar simultáneamente, creando diálogos, interacciones y diferentes combinaciones entre las firmas.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Estimular a los estudiantes a que trabajen la escucha y la elección artística frente al material presentado por sus compañeros. De esta forma, evitando que el juego se convierta en algo mecánico y proporcionando la construcción de una idea musical consistente.',
        style: ['itemList'],
      },
      {
        text:
          'Es interesante, en todos los juegos, que el profesor sea el "maestro" en la primera ronda, pero luego elige a diferentes estudiantes para asumir esa función y posibilitar que todos los estudiantes del grupo puedan, en algún momento, participar como "maestros" de alguno de los juegos de improvisación.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '5',
    gameTitle: 'Juego 5',
    content: [
      {
        text: 'Igual X Parecido X Diferente',
        style: ['title1'],
      },
      {
        text: 'Autoría: Violeta Gainza',
        style: ['paragraph'],
      },
      {
        text: 'Adaptación: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabajar las ideas de similitud y diferencia en música; proporcionar la creación a partir de un elemento dado previamente; desarrollar la idea de frases y narrativas musicales.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: 'Organizar a los estudiantes en un semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Presentar tres tarjetas. En una de ellas deberá estar representado el signo matemático de igual, en otra el signo de parecido y en otra el de diferente.',
        style: ['itemList'],
      },
      {
        text:
          'El primer estudiante debe crear libremente una frase musical, utilizando los sonidos que desee.',
        style: ['itemList'],
      },
      {
        text:
          'El profesor elige una de las tarjetas y muestra al segundo estudiante, quien debe seguir las instrucciones de la tarjeta, tocando, así, una frase igual, parecida o diferente a la frase creada por el primer estudiante.',
        style: ['itemList'],
      },
      {
        text:
          'Presentar una de las tarjetas al tercer estudiante, quien deberá ejecutar su frase siguiendo las instrucciones de la tarjeta y haciendo referencia a la frase ejecutada por el segundo estudiante. El juego sigue esa dinámica hasta que todos los estudiantes hayan participado de algunas rondas del juego.',
        style: ['itemList'],
      },
      {
        text:
          'Elegir a uno de los estudiantes para ser el “maestro” y asumir la función de presentar las tarjetas a los demás compañeros. Podemos agregar más complejidad a esta ronda del juego proponiendo que el “maestro”, además de elegir las tarjetas, también elija al estudiante que ejecutará la nueva frase. Para ello, el “maestro” debe utilizar señales de lenguaje no verbal.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Al agregar más complejidad a la variación del juego, propiciamos que los estudiantes desarrollen más atención en la escucha.',
        style: ['itemList'],
      },
    ],
  },

  {
    id: '6',
    gameTitle: 'Juego 6',
    content: [
      {
        text: 'Composición con imágenes y escritura con notación propria',
        style: ['title1'],
      },
      {
        text: 'Autoría: Diversos autores',
        style: ['paragraph'],
      },
      {
        text: 'Adaptación: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Aproximar a los estudiantes a la idea de composición; desarrollar una simbología propia que represente sus ideas musicales; entrar en contacto con diferentes formas de escritura y representación musical; llamar la atención sobre las limitaciones existentes en cualquier tipo de escritura musical; acercar a compositores e intérpretes.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text:
          'Solicitar, en la clase anterior, que los estudiantes traigan imágenes, fotos o dibujos para realizar una creación colectiva.',
        style: ['itemList'],
      },
      {
        text: 'Dividir la clase en grupos de cinco o seis estudiantes.',
        style: ['itemList'],
      },
      {
        text:
          'Cada grupo debe examinar las imágenes, fotos y dibujos y crear una historia que puede surgir a partir de la cantidad de imágenes que el grupo elija. Esa cantidad puede variar entre los diferentes grupos.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer a los estudiantes que creen una historia que presente una trama que contenga principio, medio y final.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer a los estudiantes que elijan diferentes sonidos y combinaciones para que la historia creada por ellos pueda ser representada únicamente a través de la música.',
        style: ['itemList'],
      },
      {
        text:
          'Después del momento de creación musical, distribuir para cada grupo una cartulina, una caja con lápices de colores y algunos otros materiales, como por ejemplo cintas de colores, escarbadientes, pequeñas piedras, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Cada grupo deberá “escribir” su música, utilizando para eso los signos que deseen, dibujos, palabras, símbolos, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Después de la escritura de la música, cada grupo deberá ensayar algunas veces su composición, utilizando o no el apoyo de la partitura.',
        style: ['itemList'],
      },
      {
        text: 'Proponer que cada grupo presente su música a sus compañeros.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Durante el proceso de creación de la historia y de la música, dar autonomía a los estudiantes para que ellos mismos se organicen y establezcan relaciones entre ellos, estimulando a todos a participar de este proceso. ',
        style: ['itemList'],
      },

      {
        text:
          'Dar autonomía a los estudiantes durante sus ensayos y durante la presentación. Los grupos pueden elegir como harán esta presentación, contando o no la historia creada, presentando o no la partitura.',
        style: ['itemList'],
      },
      {
        text:
          'Estimular que la comunicación entre los estudiantes se establezca de forma no verbal durante la presentación de la música.',
        style: ['itemList'],
      },
      {
        audio: audioGame6,
        style: ['audio'],
      },
    ],
  },
  {
    id: '7',
    gameTitle: 'Juego 7',
    content: [
      {
        text: 'Improvisación con ostinato',
        style: ['title1'],
      },
      {
        text: 'Autoría: Diversos autores',
        style: ['paragraph'],
      },
      {
        text: 'Adaptación: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabajar la noción de solo y tutti; trabajar la idea de ostinato; trabajar el concepto de forma musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: 'Organizar a los estudiantes en un semicírculo.',
        style: ['itemList'],
      },
      {
        text: 'Explicar a los estudiantes qué es un ostinato.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer un ostinato rítmico sencillo, a ser ejecutado, por ejemplo, con una cuerda al aire.',
        style: ['itemList'],
      },
      {
        text: 'Dividir al grupo en orquesta y solista.',
        style: ['itemList'],
      },
      {
        text:
          'El grupo que representa a la orquesta debe ejecutar el ostinato. El estudiante solista ejecuta diferentes frases o ideas musicales utilizando los sonidos que desee.',
        style: ['itemList'],
      },
      {
        text:
          'Combinar con los estudiantes cuál será la indicación que determinará el final del solo.',
        style: ['itemList'],
      },
      {
        text:
          'Después de que el estudiante ejecute el solo, el siguiente estudiante se convierte en solista, y así sucesivamente hasta que todos hayan participado en el papel de solista. ',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text: 'Durante los solos no es necesario pensar en armonía o conducción de voces.',
        style: ['itemList'],
      },
      {
        text:
          'La improvisación puede ser organizada de diferentes maneras, por ejemplo, estableciendo que luego al final de cada solo se ejecutará un número determinado de veces el ostinato o proponer una forma rondó, donde la parte A será un número fijo de veces que la orquesta ejecutará el ostinato, o un tema creado en conjunto por los estudiantes, etc.',
        style: ['itemList'],
      },
      {
        text:
          'Agregar complejidades en el transcurso de las vueltas, intercalándolas con audiciones colectivas de improvisaciones creadas por los estudiantes.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '8',
    gameTitle: 'Juego 8',
    content: [
      {
        text: 'El bosque encantado',
        style: ['title1'],
      },
      {
        text: 'Autoría: Claudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text: 'Trabajar el diálogo musical; trabajar la idea de polifonía.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: `Este juego es una variación del juego 3 (“La noche en el castillo”), con algunas dificultades añadidas.`,
        style: ['itemList'],
      },
      {
        text:
          'Posicionar a los estudiantes en diferentes puntos del aula, con una cierta distancia entre ellos. ',
        style: ['itemList'],
      },
      {
        text: 'Contar una historia sobre dos exploradores que llegan a un bosque encantado.',
        style: ['itemList'],
      },
      {
        text:
          'Cada árbol del bosque emitirá un sonido elegido por los estudiantes que lo representará.',
        style: ['itemList'],
      },
      {
        text: 'Los exploadores pueden estar con los ojos abiertos o vendados.',
        style: ['itemList'],
      },
      {
        text:
          'Al acercarse a los árboles, ellos emiten el sonido elegido por el estudiante que lo representa. Al alejarse, la intensidad del sonido va disminuyendo, y el estudiante que esté más cerca comienza a emitir el sonido elegido por él.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Debemos agregar algunas diferencias y dificultades en este juego en comparación con el juego 3.',
        style: ['itemList'],
      },
      {
        text:
          'Una de las dificultades que puede sumarse, es la participación de los “maestros”, contando así con la posibilidad de realizar interacciones y diálogos musicales entre ellos.',
        style: ['itemList'],
      },
    ],
  },
  {
    id: '9',
    gameTitle: 'Juego 9',
    content: [
      {
        text: 'Recorrido en el zoológico',
        style: ['title1'],
      },
      {
        text: 'Autoría: Violeta Gainza',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabajar diferentes posibilidades musicales de una misma sonoridad; trabajar la idea de narrativa musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: 'Organizar a los estudiantes en un semicírculo.',
        style: ['itemList'],
      },
      {
        text:
          'Contar a los estudiantes una historia sobre un visitante que llega a un zoológico y observa los diferentes animales.',
        style: ['itemList'],
      },
      {
        text:
          'Cada estudiante elige un animal para representar, eligiendo también los sonidos que lo caractericen.',
        style: ['itemList'],
      },
      {
        text:
          'El visitante realiza un recorrido por el zoológico, colocándose frente a los diferentes animales y, en ese momento, los animales reproducen el sonido elegido por los estudiantes.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Proponer que los animales emitan sus sonidos de acuerdo con las indicaciones corporales del visitante, quien debe ejecutar diferentes niveles de dinámica, intensidad y carácter musical. ',
        style: ['itemList'],
      },
      {
        text:
          'Así como en los juegos anteriores, es interesante grabar las improvisaciones, permitiendo que, en las próximas rondas de los juegos, las interacciones sean más conscientes y surjan de las elecciones musicales de los estudiantes.',
        style: ['itemList'],
      },
    ],
  },

  {
    id: '10',
    gameTitle: 'Juego 10',
    content: [
      {
        text: 'Los pájaros y el cazador',
        style: ['title1'],
      },
      {
        text: 'Autoría: Cláudia Freixedas',
        style: ['paragraph'],
      },
      {
        text: 'Adaptación: Marta Brietzke',
        style: ['paragraph'],
      },
      {
        text: 'Objetivos:',
        style: ['title2'],
      },
      {
        text:
          'Trabajar la libertad y las diferentes posibilidades para el comienzo, el desarrollo y el final de la “pieza” musical; trabajar cuestiones relacionadas con la ecología y la ecología acústica; trabajar los diálogos, las polifonías y la noción de forma musical.',
        style: ['paragraph'],
      },
      {
        text: 'Metodología:',
        style: ['title2'],
      },
      {
        text: 'Organizar a los estudiantes en un semicírculo.',
        style: ['itemList'],
      },
      {
        text: ' Preguntar a los estudiantes qué sonidos de pájaros ellos conocen.',
        style: ['itemList'],
      },
      {
        text: ' Hacer un inventario de algunos de esos sonidos con los estudiantes.',
        style: ['itemList'],
      },
      {
        text:
          'Proponer a los estudiantes que creen con sus violonchelos sonidos que representen los inventariados previamente. ',
        style: ['itemList'],
      },
      {
        text: 'Crear junto con los estudiantes un sonido que represente al cazador.',
        style: ['itemList'],
      },
      {
        text:
          ' Cada estudiante representará el sonido de uno de los pájaros, y un estudiante representará al cazador.',
        style: ['itemList'],
      },
      {
        text: 'Los pájaros deben dialogar entre sí creando un contexto musical.',
        style: ['itemList'],
      },
      {
        text:
          'Cuando lo desee, el estudiante que representa al cazador puede intervenir en el bosque. Cuando el cazador interviene, todos los pájaros se callan.',
        style: ['itemList'],
      },
      {
        text: 'Poco a poco, los pájaros vuelven a cantar y a dialogar entre sí.',
        style: ['itemList'],
      },
      {
        text: 'El cazador puede intervenir en el bosque el número de veces que lo desee.',
        style: ['itemList'],
      },
      {
        text: 'Observaciones:',
        style: ['title2'],
      },
      {
        text:
          'Otorgar autonomía a los estudiantes, dejándoles decidir cuándo empieza y cuándo termina la improvisación, así como cuánto tiempo después de la intervención del cazador los pájaros volverán a cantar.',
        style: ['itemList'],
      },
    ],
  },
]
